module.exports = __webpack_public_path__ + "images/emoji/camel.6e5bf4a6a62de2e048c5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/camel.png
// module id = 7tkn
// module chunks = 2